import React from 'react';

const Topic = (props) => {
  //let cssClass = props.cssClass ? props.cssClass : "";
  console.log('Topic', props);
  
  let centerText;
  switch(props.options) {
    case 'questions':
        centerText = 
            <div align="center">
                <h3>マリモメンバーズシップヘご入会いただき、誠にありがとうございます。</h3>
                <h5>
                マリモメンバーズシップでは、弊社ならびにグループ企業が取り扱う各種サービス・商品に関する
                幅広い情報をメール等にてお届けいたします。<br />
                ※会員規約を必ずご一読ください。入会金・年会費無料
                </h5>
                <br />
                <a href="http://www.polestar-m.jp/members_ship/apply/new/pdf/151120membersship.pdf" target="_blank">※会員規約</a>を必ずご一読ください。<font color="#0000FF">入会金・年会費無料</font>
            </div>;
        break;
    case 'checlist':
        centerText = 
            <div align="center">
                <div>この内容で送信します。入力内容にお間違いがないかご確認ください。</div>
            </div>
        break;
    case 'finish':
        centerText = 
            <div align="center">
                <div>ありがとうございました。</div>
            </div>
        break;
    default:
  }


  return (  
    <div className="topic">
        
        <div className={'cmn-order-navi'}>
            <ul>
            <li  className={props.options === 'questions' ? 'active' : '' }><span className={'navi-num'}>1</span><span className={'navi-label'}>入力</span></li>
            <li  className={props.options === 'checlist' ? 'active' : '' }><span className="navi-num">2</span><span className="navi-label">確認</span></li>
            <li  className={props.options === 'finish' ? 'active' : '' }><span className="navi-num">3</span><span className="navi-label">完了</span></li>
            </ul>
        </div>

        {centerText} 

    </div>
  )
}

export default Topic;